import { ApolloClient } from 'apollo-client';
import apolloLink from './apolloLink';
import apolloCache from './apolloCache';

const client = new ApolloClient({
  link: apolloLink,
  cache: apolloCache,
  resolvers: {},
});

export default client;



// WEBPACK FOOTER //
// ./app/apolloClient.js